import { handleActions } from 'redux-actions';
import * as filtersActions from '../actions/filters';

let initState = {
  count: 0,
  fields: null,
  search: null,
  typeList: null,
};

export const filters = handleActions(
  {
    [filtersActions.updateFilterFieldsOrders]: (state, action) => {
      return {
        ...state,
        fields: action.payload,
      };
    },
    [filtersActions.searchOrders]: (state, action) => {
      return {
        ...state,
        search: action.payload,
      };
    },
    [filtersActions.changeTypeListOrders]: (state, action) => {
      return {
        ...state,
        typeList: action.payload,
      };
    },
    [filtersActions.countFiltersOrders]: (state, action) => {
      return {
        ...state,
        count: action.payload,
      };
    },
    [filtersActions.resetFiltersOrders]: (state, action) => {
      return {
        ...state,
        fields: null,
        search: null,
        count: 0,
      };
    },
  },
  initState
);
